export default __webpack_public_path__ + "static/favicon.3e949f01f9f7879b66d2c8ffd49ceca0.ico";